import React, { Component } from 'react';
import { Input, Header, Message, Icon } from 'semantic-ui-react';

// import './forms_inputs_text.css';

class FormsInputsPassword extends Component {
    state = {
        showPassword: false,
    };

    handleTogglePassword() {
        this.setState({ showPassword: !this.state.showPassword });
    };

    render() {
        const { showPassword } = this.state;
        const { field, form: {touched, errors}, ...props } = this.props;
        const hasError = (errors[field.name] && touched[field.name]) ? true : false;
        return (
            <div className="field">
                <>
                    <Header as='h5'>{props.label}</Header>
                    {(props.secondaryLabel) ? <Header.Subheader>{props.secondaryLabel}</Header.Subheader>: ''}
                </>
                <Input
                    icon={ <Icon link name={showPassword ? 'eye' : 'eye slash outline'} onClick={() => this.handleTogglePassword()}/> }
                    fluid type={showPassword ? 'text' : 'password'} disabled={(props.disabled) ? props.disabled : false} {...field}
                />
                {
                    hasError &&
                    (
                        <Message negative>
                            {errors[field.name]}
                        </Message>
                    )
                }
            </div>
        );
    };
}

export default FormsInputsPassword;
